/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';
import { PromoEntity } from './promoEntity';


export interface UpdateEventDto { 
    /**
     * External route URL for this activity
     */
    routeUrl?: string;
    /**
     * Remove the saved route URL from this activity
     */
    removeRouteUrl?: boolean;
    /**
     * Remove the saved end location from this activity
     */
    removeEndLocation?: boolean;
    ownerId: string;
    acceptAnyLvl?: boolean;
    handiFriendly?: boolean;
    addressName?: string;
    backgroundUrl?: string;
    description?: string;
    distance?: number;
    duration?: number;
    level?: number;
    location?: GeoLocationEntity;
    maxNbAttendees?: number;
    /**
     * Optional minimum participants (organiser counted in). Hand-added like in
     * createEventDto, because `generate:sdk` needs a running API.
     */
    minParticipants?: number;
    /**
     * Remove the confirmation threshold entirely. Hand-added like
     * minParticipants above, because `generate:sdk` needs a running API; mirrors
     * removeRouteUrl/removeEndLocation.
     */
    removeMinParticipants?: boolean;
    attendeesMode?: UpdateEventDto.AttendeesModeEnum;
    pace?: string;
    sessionKindId?: string;
    sportId?: string;
    startDate?: string;
    title?: string;
    groupId?: string;
    verticalDrop?: number;
    privacy?: UpdateEventDto.PrivacyEnum;
    repeatWeekly?: boolean;
    endDate?: string;
    type?: string;
    costPerParticipant?: number;
    isPaidOut?: boolean;
    commissionPercent?: number;
    listPromos?: Array<PromoEntity>;
    commissionId?: string;
    cgvId?: string;
}
export namespace UpdateEventDto {
    export type AttendeesModeEnum = 'preset' | 'manual';
    export const AttendeesModeEnum = {
        Preset: 'preset' as AttendeesModeEnum,
        Manual: 'manual' as AttendeesModeEnum
    };
    export type PrivacyEnum = 'public' | 'private' | 'members_only';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        MembersOnly: 'members_only' as PrivacyEnum
    };
}


